import { css } from '@emotion/core';
import { tokens, media } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var regionGroupLink = /*#__PURE__*/css(typography.headingCaps, " display:block;text-decoration:none;color:", colors.neutral.heavy.default, ";border-bottom:1px solid ", colors.neutral.trim.default, ";padding:10px 0;text-transform:uppercase;&:hover{color:", colors.neutral.heavy.hover, ";background-color:", colors.neutral.surface.hover, ";}");
export var regionGroupItems = /*#__PURE__*/css("margin:auto 17px;", media('>=desktop'), "{margin:auto;}");
export var regionGroupLinkIcon = {
  name: "146q31f",
  styles: "float:right;"
};